import React from "react";

function Projects() {
  return (
    <div className="my-5 p-3 rounded-md border border-soli shadow-md hover:border-green-300">
      <h1 className="text-4xl font-bold mb-2">Projects</h1>
      <div className="grid grid-cols-3 gap-4">
        {/* 식당 웨이팅 팀 프로젝트 */}
        <div className="flex flex-col my-2">
          <h2 className="mb-2 text-2xl font-bold">[팀]식당 웨이팅</h2>
          <ul className="w-full space-y-1 box-border">
            <li
              className="group flex justify-center w-4/5 border-solid border rounded-lg p-2 text-align-center cursor-pointer hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"
              onClick={() => {
                window.open(
                  // 여기와 아래 링크 모두 같은 걸로 수정
                  "https://github.com/sonbuwon/project3_backend#project3_backend",
                  "_blank"
                );
              }}
            >
              <a
                className="text-xl hover:text-white group-hover:text-white"
                // 여기와 위 링크 모두 같은 걸로 수정
                href="https://github.com/sonbuwon/project3_backend#project3_backend"
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()} // 이 부분은 <li>의 onClick 이벤트와 중복 실행을 방지하기 위함입니다.
              >
                GitHub
              </a>
            </li>
            <li
              className="group flex justify-center w-4/5 border-solid border rounded-lg p-2 text-align-center cursor-pointer hover:bg-black"
              onClick={() => {
                window.open(
                  "https://crystalline-vicuna-43c.notion.site/fooeating-5258f1f732414504a5c20c093a1e463f?pvs=4",
                  "_blank"
                );
              }}
            >
              <a
                className="text-xl hover:text-white group-hover:text-white"
                href="https://crystalline-vicuna-43c.notion.site/fooeating-5258f1f732414504a5c20c093a1e463f?pvs=4"
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                Notion
              </a>
            </li>
          </ul>
        </div>
        {/* 포토 카드 갤러리 */}
        <div className="flex flex-col my-2">
          <h2 className="mb-2 text-2xl font-bold">[개인]포토 카드 갤러리</h2>
          <ul className="w-full space-y-1 box-border">
            <li
              className="group flex justify-center w-4/5 border-solid border rounded-lg p-2 text-align-center cursor-pointer hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"
              onClick={() => {
                window.open(
                  "https://github.com/sonbuwon/ProjectsWithSpring#1-%ED%8F%AC%ED%86%A0-%EC%B9%B4%EB%93%9C-%EA%B0%A4%EB%9F%AC%EB%A6%AC",
                  "_blank"
                );
              }}
            >
              <a
                className="text-xl hover:text-white group-hover:text-white"
                href="https://github.com/sonbuwon/ProjectsWithSpring#1-%ED%8F%AC%ED%86%A0-%EC%B9%B4%EB%93%9C-%EA%B0%A4%EB%9F%AC%EB%A6%AC"
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()} // 이 부분은 <li>의 onClick 이벤트와 중복 실행을 방지하기 위함입니다.
              >
                GitHub
              </a>
            </li>
            <li
              className="group flex justify-center w-4/5 border-solid border rounded-lg p-2 text-align-center cursor-pointer hover:bg-black"
              onClick={() => {
                window.open(
                  "https://crystalline-vicuna-43c.notion.site/5ff1fc298205490db6c2c5f7a900e393",
                  "_blank"
                );
              }}
            >
              <a
                className="text-xl hover:text-white group-hover:text-white"
                href="https://crystalline-vicuna-43c.notion.site/5ff1fc298205490db6c2c5f7a900e393"
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                Notion
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Projects;
